import { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';

// @Utility
import { setStorage } from "@utility/app/storage";

// Component
import WrapperContainer from "views/components/WrapperContainer";
import Content from "./component/Content";
import Rank from "views/templates/fes5567/component/Rank/index";

const HomeApp = ({ dataSetting, isLargeScreen }) => {
    document.title = "หน้าหลัก";
    const { pathname } = useLocation();
    const { random, code } = useParams();

    useEffect(() => {
        if (random !== undefined && code !== undefined) {
            let urlPath = pathname.split('/');

            // เก็บข้อมูลเพื่อนที่เชิญ
            if (urlPath[2] === "affiliate") {
                setStorage("affiliate", code)
            }

            // อ้างอิง
            if (urlPath[2] === "refer") {
                setStorage("refer", code)
            } else if (urlPath[2] === "ref") {
                setStorage("refer", code)
            }

            // การตลาด
            if (urlPath[2] === "market") {
                setStorage("market", code)
            }
        }
    }, [random, code]);

    return (
        <>
            <WrapperContainer className="contentWidth" maxWidth="xxl">
                <Content dataSetting={dataSetting} isLargeScreen={isLargeScreen}></Content>
            </WrapperContainer>

            <br />
            <div className="componentMarginTop">
                {
                    (dataSetting?.cms?.section_withdraw_rank === "1" || dataSetting?.cms?.section_withdraw_rank === 1) && (
                        <Rank dataCms={dataSetting?.cms} pageName="รายงานผลอันดับการถอนเงิน" />
                    )
                }
            </div>
        </>
    );
}

export default HomeApp;